import { Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';
import { Event } from '../../entities/events/event';
import * as fromGraphQl from './graphql';
import { EventsComponent } from './events.component';

export class EventsDataSource extends NXDataSourcePrime<Event> {
  constructor(apollo: Apollo,
    @Inject('env') environment: any,
    private eventsComponent: EventsComponent
    ) {
    super(apollo, fromGraphQl.EVENTS_QUERY, environment);
  }
  public selectedEvent: Event;

  handleSubscriptionResult(data: fromGraphQl.EventsQueryResponse): void {
    super.setSubject(
      data?.events?.content ? data?.events?.content : [],
      data?.events?.totalElements ? data?.events.totalElements : 0
    );
    if (data?.events?.totalElements > 0) {
      if(!this.selectedEvent) {
        this.selectedEvent = data?.events?.content[0];
        this.eventsComponent.setMenuItems();
      }
    }
    else {
      this.selectedEvent = null;
    }
    this.querySubscription?.unsubscribe();
  }

  loadEvents(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
